import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PERSONALISATION_EDIT, PERSONALISATION_VIEW_TABS } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { getCurrencyNameFromCode } from '../../../../../utils/commonUtils';
import {
  allPersonalisationsSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './Personlaisation-View.scss';

const PersonalisationView = (props) => {
  const { personalisation, onViewToggle, toggleDrawer, selectedHotel, permissions } = props;
  const [selectedPersonalisation, setSelectedPersonalisation] = useState(personalisation);
  const [tabValue, setTabValue] = useState(0);
  const currency = useSelector(selectedHotelCurrencySelector);
  const originalPersonalisations = useSelector(allPersonalisationsSelector);

  useEffect(() => {
    // retreiving selected category details from api
    const personalisationObj = {
      ...originalPersonalisations.find(
        (tempPersonalization) => tempPersonalization.id === personalisation.id,
      ),
    };
    setSelectedPersonalisation(personalisationObj);
  }, [selectedHotel, originalPersonalisations]);

  const onClickEdit = (event) => {
    toggleDrawer(PERSONALISATION_EDIT, true, selectedPersonalisation);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12 mb-4'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Personalisation Name</div>
                <div className='details-value preview-breaks'>{selectedPersonalisation.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Status</div>
                <div className='details-value'>
                  <div
                    className={`${
                      selectedPersonalisation.isActive ? 'pill-active' : 'pill-inactive'
                    } col-md-2 pill-text pill mt-3`}
                  >
                    {selectedPersonalisation.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Unit</div>
                <div className='details-value'>{selectedPersonalisation.unit}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Max Quantity</div>
                <div className='details-value'>
                  {selectedPersonalisation.maxQuantity?.status === 'active'
                    ? selectedPersonalisation.maxQuantity?.maxQuantityValue
                    : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Personalisation Category</div>
                <div className='details-value'>
                  {selectedPersonalisation?.personalisationCategory?.categoryName || '---'}
                </div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Cost</div>
                <div className='details-value'>
                  {getCurrencyNameFromCode(currency)} {selectedPersonalisation.cost}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {selectedPersonalisation.description}
                </div>
              </div>
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedPersonalisation?.images || []}
              enabledMediaTabs={['image']}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedPersonalisation && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={PERSONALISATION_VIEW_TABS}
          onViewToggle={onViewToggle}
          title={selectedPersonalisation.name}
          createdUserId={selectedPersonalisation.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-4'
        />
      )}
    </>
  );
};

export default PersonalisationView;
